import React, { useState } from "react";
import thongTinSanPham from "../assets/thongtinsanpham.png";
import OrderFormModal from "./oderForm.js";
import amchen3 from "../assets/amchen3.png";
import amchen4 from "../assets/amchen4.png";
import amchen6 from "../assets/amchen6.png";
import iconButton from "../assets/Vector.png";
import amchen5 from "../assets/amchen5.png";
import amchen1 from "../assets/Frame 2147223335 (1).png";
import title from "../assets/BỘ BÀN TRÀ RR88 CAO CẤP.png";

const GiftDetailModal2 = ({ isOpen, closeModal }) => {
  const [isOderFormModalOpen, setIsOderFormModalOpen] = useState(false);
  const closeOderFormModal = () => setIsOderFormModalOpen(false);
  if (!isOpen) return null;
  return (
    <>
      <div className="fixed  inset-0 bg-black bg-opacity-50 z-20 flex items-center justify-center">
        <div className="relative bg-white p-8 rounded-lg w-[950px] h-[870px] max-w-[1400px] max-h-[800px] overflow-auto shadow-lg md:block hidden">
          <h2 className="font-bold pb-3 border-b-2 mb-5">THÔNG TIN SẢN PHẨM</h2>
          <div className="flex space-x-4">
            <div className="text-black p-1 w-3/5 flex gap-2">
              <img src={amchen1} alt="" className="w-[400px]" />
              <div>
                <img src={amchen3} alt="" />
                <img src={amchen4} alt="" />
                <img src={amchen5} alt="" />

                <img src={amchen6} alt="" />
              </div>
            </div>
            <div className="relative p-1 w-2/5">
              <img src={title} alt="" />

              <button
                className="relative mx-auto bg-blue-500 text-white px-10 py-2 rounded-l-full m-10 rounded-r-full hover:bg-blue-600 flex gap-2"
                onClick={() => setIsOderFormModalOpen(true)}
                style={{
                  backgroundImage: `url(/images/bgButton.png)`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                }}
              >
                <img src={iconButton} alt="icon" />
                ĐĂNG KÝ NHẬN
              </button>
            </div>
          </div>
          <div className="mt-5 text-[13px] font-semibold">
            Nghệ thuật thưởng trà luôn có ở mỗi con người Việt Nam. Văn hóa uống
            trà với chén trà mở đầu câu chuyện in dấu mạnh mẽ trong đời sống
            người dân Việt Nam gắn kết yêu thương giữa người với người vì vậy từ
            01/01/2025 RR88 triển khai chương trình tặng Bộ Bàn Trà cao cấp cho
            các thành viên VIP có cược hợp lệ trong tháng từ 100,000 điểm. Hãy
            nhanh tay tham gia ngay tại RR88 để nhận ưu đãi cực HOT.
          </div>
          <button
            onClick={closeModal}
            className="absolute top-4 right-4 text-black bg-gray-200 rounded-full p-2 hover:bg-gray-300"
          >
            ✕
          </button>
        </div>
        {/* mobile */}
        <div className="relative bg-[#EFF6FF] top-[25px] mx-3 p-3 rounded-lg w-[400px] h-[80%] max-w-[1400px] h-[91%] top-[33px] responsive_mobile  overflow-auto shadow-lg md:hidden block">
          <h2 className="font-bold pb-3 border-b-2 mb-3">THÔNG TIN SẢN PHẨM</h2>

          <div className="w-full bg-gray-100">
            <div className="flex flex-col gap-6">
              <div className="text-black p-1 w-full">
                <img src={title} alt="" className="w-[250px] mb-3" />

               <div className="text-black p-1 flex gap-2">
              <img src={amchen1} alt="" className="w-[79%]" />
              <div className="flex flex-col gap-2">
                <img src={amchen3} alt="" />
                <img src={amchen4} alt="" />
                <img src={amchen5} alt="" />

                <img src={amchen6} alt="" />
              </div>
            </div>
             <div>
              <button
                className="relative mx-auto bg-blue-500 text-white px-10 py-2 rounded-l-full my-5 rounded-r-full hover:bg-blue-600 flex gap-2"
                onClick={() => setIsOderFormModalOpen(true)}
                style={{
                  backgroundImage: `url(/images/bgButton.png)`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                }}
              >
                <img src={iconButton} alt="icon" />
                ĐĂNG KÝ NHẬN
              </button>
            </div>

                <p className="font-semibold">
                  {" "}
                  {/* Đảm bảo chữ không bị nhảy xuống */}
                  Nghệ thuật thường trà luôn có ở mỗi con người Việt Nam. Văn
                  hóa uống trà với chén trà mở đầu câu chuyện in dấu mạnh mẽ
                  trong đời sống người dân Việt Nam gắn kết yêu thương giữa
                  người với người vì vậy từ 01/01/2025 RR88 triển khai chương
                  trình tặng Bộ Bàn Trà cao cấp cho các thành viên VIP có cược
                  hợp lệ trong tháng từ 100,000 điểm. Hãy nhanh tay tham gia
                  ngay tại RR88 để nhận ưu đãi cực HOT.
                </p>
                
              </div>
            </div>
          </div>
          <button
            onClick={closeModal}
            className="absolute right-[8px] top-3 text-black bg-gray-200 rounded-full p-2 hover:bg-gray-300"
          >
            ✕
          </button>
        </div>
      </div>
      <OrderFormModal
        isOpen={isOderFormModalOpen}
        closeModal={closeOderFormModal}
        gender=""
        size=""
        type={2}
        checkPoint={100000}
      />
    </>
  );
};
export default GiftDetailModal2;
